document.addEventListener('DOMContentLoaded', function() {

    if (customerEmail && (customerEmail.endsWith('@ppg.com') || customerEmail.endsWith('@pittsburghpaints.com'))) {
      console.log('Customer has a PPG email address. Exiting script.');
      return;
    }
  
    if (hasInfinitePanelsTag) {
      console.log('Customer has InfinitePanels tag. Exiting script.');
      return;
    }
  
    const panelKeyword = "panel";
    const maxPanels = 10;
  
    console.log('Script loaded. Checking cart...');
  
    // Fetch cart details using Shopify's AJAX API
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart fetched:', cart);
  
        let panelCount = 0;
  
        // Loop through cart items to count products whose handle contains "panel"
        cart.items.forEach(item => {
          console.log('Checking item handle:', item.handle);
          if (item.handle.toLowerCase().includes(panelKeyword)) {
            panelCount += item.quantity;
            console.log(`Panel item found: ${item.title} - Quantity: ${item.quantity}`);
          }
        });
  
        console.log(`Total panel count: ${panelCount}`);
  
        // Disable the "Checkout" button if the limit is reached (using >= to cap at maxPanels)
        if (panelCount >= maxPanels) {
          const checkoutButton = document.getElementById('checkout-button');
          if (checkoutButton) {
            console.log('Disabling Checkout button');
            checkoutButton.disabled = true;
            checkoutButton.style.pointerEvents = 'none';
            checkoutButton.style.backgroundColor = '#ccc'; // Optional: Change button style
            checkoutButton.textContent = "Panel Limit Exceeded";
          }
        } else {
          console.log('Panel limit not reached, Checkout button remains active.');
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  });
  